import React, { useState, useEffect } from 'react';

// Fügen Sie das CSS für die Puls-Animation direkt im JavaScript hinzu.
// In einer echten App würden Sie dies in einer separaten CSS-Datei oder
// einem Styled-Components-Ansatz verwalten.
const style = document.createElement('style');
style.innerHTML = `
  @keyframes pulse-animation {
    0% {
      transform: scale(1);
      opacity: 1;
    }
    50% {
      transform: scale(0.6);
      opacity: 0.7;
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }
`;

const PulsatingCircle = () => {
    const [styleInjected, setStyleInjected] = useState(false);

    // Fügt das Animations-CSS in den Header ein, sobald die Komponente gemountet wird
    useEffect(() => {
        if (!styleInjected) {
            document.head.appendChild(style);
            setStyleInjected(true);
        }
        // Cleanup-Funktion (optional, für sauberes Unmounting)
        return () => {
            // Wenn das CSS nur für diese eine Komponente ist, könnte man es hier entfernen
            // document.head.removeChild(style);
        };
    }, [styleInjected]);

    const circleStyle = {
        backgroundColor: '#CC2200',
        width: '16px',
        height: '16px',
        borderRadius: '50%', // Macht es zu einem Kreis
        marginRight: '8px',
        // Wichtig: Wendet die CSS-Keyframe-Animation an
        animation: 'pulse-animation 1.5s infinite ease-in-out',
    };

    const containerStyle = {
        display: 'flex',
        alignItems: 'center', // Zentriert Kreis und Text vertikal
        fontSize: '16px',
    };

    return (
        <div style={containerStyle}>
            <div style={circleStyle} />
        </div>
    );
};

export default PulsatingCircle;